import { render } from "./ProyectoForm.vue?vue&type=template&id=2e3eecda&scoped=true"
import script from "./ProyectoForm.vue?vue&type=script&lang=js"
export * from "./ProyectoForm.vue?vue&type=script&lang=js"

import "./ProyectoForm.vue?vue&type=style&index=0&id=2e3eecda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3eecda"]])

export default __exports__